import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import SocialMediaLinkList from '../common/social-media-link-list';

import styles from './member.module.scss';

const Member = ({ name, title, description, image, social }) => (
  <div styleName="container">
    <div styleName="card front" style={{ backgroundImage: `url(${image})` }} />
    <div styleName="card back" className="grid-x align-middle align-center">
      <div className="cell">
        <h3>{name}</h3>
        <p>{title}</p>
        <p>{description}</p>
        <SocialMediaLinkList items={social} />
      </div>
    </div>
  </div>
);
Member.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  social: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};
Member.defaultProps = {
  name: '',
  title: '',
  description: '',
  image: '',
  social: [],
};

export const MemberType = PropTypes.shape(Member.propTypes);

export default CSSModules(Member, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/who-we-are/member.jsx